import { delay, put, takeEvery } from 'redux-saga/effects';

import { SPAWN_NOTIFICATION, destroyNotification } from '../actions';

function* spawnNotificationTask({ payload: { id, timeout } }) {
	if (timeout === 0) {
		return;
	}

	yield delay(timeout);
	yield put(destroyNotification(id));
}

export default function* watchSpawnNotification() {
	yield takeEvery(SPAWN_NOTIFICATION, spawnNotificationTask);
}
